import React from "react";
import ICON from "../icons.js";
import { stripJuristic } from "../../../components/text-sanitize.js";
import { telUrl, lineUrl, normalizePhone } from "../../../components/sale-format.js";

/* ============================================================================
 * HomeCta — แถบชวนติดต่อสอบถาม ปิดท้ายก่อนฟุตเตอร์
 *
 * รวมช่องทางติดต่อไว้บรรทัดเดียว ผู้ใช้ที่มีคำถามจะได้ไม่ต้องเลื่อนลงไปหาเบอร์
 * ในฟุตเตอร์ · ดูรวมทุกโครงการ = แสดงเบอร์ของทุกโครงการ เพราะไม่มีเบอร์กลาง
 *
 * ★ เบอร์ซ้ำขึ้นครั้งเดียว — โครงการที่ยังไม่บันทึกข้อมูลบริษัท backend ใส่ office_phone
 *   เป็นเบอร์โครงการให้ ถ้าไม่ตัดซ้ำจะมีปุ่มเบอร์เดียวกัน 2 ปุ่มติดกัน
 * ★ ดูรวมทุกโครงการใช้ card_phone / card_name (ข้อมูลบริษัทของแต่ละโครงการ) ก่อน
 *   ตรงกับที่การ์ดโครงการแสดง — ไม่ใช่เบอร์โครงการดิบ
 * ========================================================================== */
export default function HomeCta({ content, setting = {}, project, projects = [], onContact }) {
    // รวมเบอร์ทั้งหมดตามลำดับความสำคัญ แล้วตัดตัวที่เลขซ้ำกัน (เทียบหลัง normalize)
    const seen = new Set();
    const phones = [];
    const addPhone = (key, value, label) => {
        const digits = normalizePhone(value);
        if (!digits || seen.has(digits) || !telUrl(value)) return;
        seen.add(digits);
        phones.push({ key, value, label });
    };

    // ช่องทางของบริษัท (ตั้งจากหลังบ้าน) มาก่อนเสมอ เป็นเบอร์กลางที่รับสายได้จริง ส่วนเบอร์โครงการเป็นทางเลือกรอง
    addPhone("hotline", setting.hotline, `สายด่วน ${setting.hotline}`);
    addPhone("office", setting.office_phone, `สำนักงาน ${setting.office_phone}`);
    if (project) {
        addPhone("project", project.phone_number, project.phone_number);
    } else {
        projects.forEach((p) => {
            const phone = p.card_phone || p.phone_number;
            addPhone(`p-${p.project_id}`, phone, `${stripJuristic(p.card_name || p.project_name)} · ${phone}`);
        });
    }

    const email = String(setting.email || "").trim();
    const line = lineUrl(setting.line_id);

    return (
        <div className="hm-container" id="hm-contact">
            <section className="hm-cta">
                <div className="hm-cta__text">
                    <h2 className="hm-cta__title">{stripJuristic(content?.title) || "สนใจห้องไหน ติดต่อเราได้เลย"}</h2>
                    <p className="hm-cta__desc">{stripJuristic(content?.body) || "เจ้าหน้าที่พร้อมให้ข้อมูลและนัดเวลาเข้าชมห้อง"}</p>
                </div>

                <button type="button" className="hm-btn hm-btn--primary hm-btn--sm" onClick={onContact}>
                    ฝากข้อมูลติดต่อกลับ
                </button>

                <div className="hm-cta__channels">
                    {phones.map((p) => (
                        <a key={p.key} className="hm-channel" href={telUrl(p.value)}>
                            <span className="hm-channel__icon hm-ico">{ICON.phone}</span>
                            <span>{p.label}</span>
                        </a>
                    ))}
                    {!!email && (
                        <a className="hm-channel" href={`mailto:${email}`}>
                            <span className="hm-channel__icon hm-ico">{ICON.mail}</span>
                            <span>{email}</span>
                        </a>
                    )}
                    {/* ★ ใช้ lineUrl ตัวเดียวกับหน้าห้อง — รองรับลิงก์เต็ม / @OA / LINE ID ส่วนตัว */}
                    {!!line && (
                        <a className="hm-channel" href={line} target="_blank" rel="noreferrer">
                            <span className="hm-channel__icon hm-ico">{ICON.comment}</span>
                            <span>{setting.line_id}</span>
                        </a>
                    )}
                </div>
            </section>
        </div>
    );
}
